import api from './index.js';
const path = '/api/internal/session';
export default { signOut() { return api({ method: 'delete', url: path }); } };
